export const FIELDS = {
  ACTIVE: 'active',
  ALLOCATED: 'allocated',
  ALT_NUMBER: 'altNumber',
  AVAILABLE: 'available',
  BIN: 'bin',
  CATEGORY_NAME: 'categoryName',
  CLASS_NAME: 'className',
  COMPANY_ID: 'companyId',
  COMPANY_NAME: 'companyName',
  CONDITION_ID: 'conditionId',
  CONDITION_NAME: 'conditionName',
  COUNTRY_OF_ORIGIN_ID: 'countryOfOriginId',
  COUNTRY_OF_ORIGIN_NAME: 'countryOfOriginName',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CUSTOMER_ID: 'customerId',
  CUSTOMER_NAME: 'customerName',
  DATE_CODE: 'dateCode',
  DESCRIPTION: 'description',
  DESTROYED: 'destroyed',
  HARMONIZED_CODE: 'harmonizedCode',
  ID: 'id',
  INTERNAL_PN: 'internalPn',
  INVENTORY_CATEGORY_ID: 'inventoryCategoryId',
  INVENTORY_CLASS_ID: 'inventoryClassId',
  INVENTORY_ID:'inventoryId',
  IS_QUARANTINED: 'isQuarantined',
  LEAD_FREE: 'leadFree',
  LOCATION: 'location',
  LOT_CODE: 'lotCode',
  MANUFACTURER_ID: 'manufacturerId',
  MANUFACTURER_NAME: 'manufacturerName',
  NSNNUMBER: 'nsnNumber',
  ON_HAND: 'onHand',
  PACKAGE_ID: 'packageId',
  PACKAGE: 'package',
  PART_COMMENTS: 'partComments',
  PART_ID: 'partId',
  PART_NUMBER: 'partNumber',
  VENDOR_PART_NUMBER: 'vendorPartNumber',
  PHYS_PKG: 'physPkg',
  PIECE_PER_PKG: 'piecePerPkg',
  PURCHASE_ORDER_LINE_ID: 'purchaseOrderLineId',
  QTY_ALLOCATED:'qtyAllocated',
  QTY_AVAILABLE:'qtyAvailable',
  QTY_SHIPPED:'qtyShipped',
  QTY_SOLD:'qtySold',
  RACK: 'rack',
  RETURNED: 'returned',
  REVISION: 'revision',
  SALES_ORDER_ID:'salesOrderId',
  SALES_ORDER_LINE_ID:'salesOrderLineId',
  SHELF: 'shelf',
  TEMP_RATING: 'tempRating',
  UO_MID: 'uoMId',
  UOM: 'uom',
  WAREHOUSE_ID: 'warehouseId',
  WAREHOUSE_NAME: 'warehouseName',
  SO_DATE:'soDate',
  STATUS:'status',
  WARRANTY_ID:'warrantyId',
  WARRANTY_NAME:'warrantyName',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIEDY_USER_FULL_NAME: 'modifiedyUserFullName',
};
